import {UserAuthenticationBaseRequestDto, UserAuthenticationBaseResponseDto} from '../user-authentication-base.dto';
import {AutoMap} from '@automapper/classes';

export class SubmitVerificationCodeRequestDto extends UserAuthenticationBaseRequestDto {
  @AutoMap()
  public email!: string

  @AutoMap()
  public code!: string
}

export class SubmitVerificationCodeResponseDto {
  @AutoMap()
  public doesUserExist!: boolean;

  @AutoMap()
  public data!: UserAuthenticationBaseResponseDto;
}
